import * as React from "react";

interface Props {
  total: number;
}

export const SnapshotCollectionsOutcomesSearchHeader: React.FC<Props> = ({ total }) => (
  <thead className="bg-gray-50">
    <tr>
      <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
        <div>Results ({total} documents)</div>
      </th>

      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
        <div className="text-right">Actions</div>
      </th>
    </tr>
  </thead>
);
